import React from "react"
import YemenDBrev from "./YemenDBrev"
import { ResponsiveBarCanvas } from '@nivo/bar'
import {
    Container,
    Col,
    Row} from 'reactstrap';
// import Draggable, {DraggableCore} from 'react-draggable';

class NivoDemo extends React.Component{



    constructor() {
      super()
      this.state = {
          count: 0
      }
  }

handleClick() {
  // this.setState({ count: 1 })
  var mysound = new window.Howl({
    src: ['audio/abcdefg.mp3'],
    volume:0.2,
    sprite: {
      a: [0, 600],
      b: [700, 500],
      c: [1200, 500],
      d: [1900, 500],
      e: [2400, 500],
      f: [2900, 500],
      g: [3400, 500]
  }
  });
  
  let arrs=["a","b","c","d","e","f","g"]
  let arrl=arrs.length;
  let timer=5000/arrl
    var i, _i, _results;
    _results = [];
    for (i = _i = 0; _i <= arrs.length-1; i = ++_i) {
      _results.push((function(i) {
        return setTimeout(function() {
          return mysound.play(arrs[i]);
        }, i * timer);
      })(i));
    }
}
handleShot() {
  // this.setState({ count: 1 })
  var myshot = new window.Howl({
    src: ['audio/bomb.mp3'],
    volume:0.2,
    sprite: {
      a: [0, 1500],
      g: [2000, 1500],
      c: [4000, 1500],
      f: [6000, 1500],
      e: [8000, 1500],
      d: [10000, 1500],
      b: [12000, 1500]
  }
  });
  
  // let arr=["a","a","a","a","a","a","a","a","a","a"]
  let arr=["a"]
  
  let arrl=arr.length;
  let timer=3000/arrl
  
    var i, _i, _results;
    _results = [];
    for (i = _i = 0; _i <= arrl-1; i = ++_i) {
      _results.push((function(i) {
        return setTimeout(function() {
          return myshot.play(arr[i]);
        }, i * timer);
      })(i));
    }
  }


handleShot1() {
  var myshot = new window.Howl({
    src: ['audio/bomb.mp3'],
    volume:0.2,
    sprite: {
      a: [0, 1500],
      g: [2000, 1500],
      c: [4000, 1500],
      f: [6000, 1500],
      e: [8000, 1500],
      d: [10000, 1500],
      b: [12000, 1500]
  }
  });
  let arr=["a","a","a","b","b","b","b","d","d","d"]
  let arrl=arr.length;
  let timer=3000/arrl
    var i, _i, _results;
    _results = [];
    for (i = _i = 0; _i <= arrl-1; i = ++_i) {
      _results.push((function(i) {
        return setTimeout(function() {
          return myshot.play(arr[i]);
        }, i * timer);
      })(i));
    }
  }


handleShot2() {
var myshot = new window.Howl({
  src: ['audio/bomb.mp3'],
  volume:0.2,
  sprite: {
    a: [0, 1500],
    g: [2000, 1500],
    c: [4000, 1500],
    f: [6000, 1500],
    e: [8000, 1500],
    d: [10000, 1500],
    b: [12000, 1500]
}
});
let arr=["a","a","a","a","a","b","b","b","b","b","c","c","c","c","c","c","c","c","c","c"]
let arrl=arr.length;
let timer=3000/arrl
var i, _i, _results;
_results = [];
for (i = _i = 0; _i <= arrl-1; i = ++_i) {
_results.push((function(i) {
return setTimeout(function() {
return myshot.play(arr[i]);
}, i * timer);
})(i));
}
}


handleShot3() {
var myshot = new window.Howl({
  src: ['audio/bomb.mp3'],
  volume:0.2,
  sprite: {
    a: [0, 1500],
    g: [2000, 1500],
    c: [4000, 1500],
    f: [6000, 1500],
    e: [8000, 1500],
    d: [10000, 1500],
    b: [12000, 1500]
}
});
let arr=["a","a","a","a","a","a","a","b","b","b","b","b","c","c","c","c","c","d","d","d","d","d","e","e","f","g","g","g","g","g"]
let arrl=arr.length;
let timer=3000/arrl
var i, _i, _results;
_results = [];
for (i = _i = 0; _i <= arrl-1; i = ++_i) {
_results.push((function(i) {
return setTimeout(function() {
return myshot.play(arr[i]);
}, i * timer);
})(i));
}
}



handleShot4() {
var myshot = new window.Howl({
  src: ['audio/bomb.mp3'],
  volume:0.2,
  sprite: {
    a: [0, 1500],
    g: [2000, 1500],
    c: [4000, 1500],
    f: [6000, 1500],
    e: [8000, 1500],
    d: [10000, 1500],
    b: [12000, 1500]
}
});
let arr=["a","a","a","a","a","b","b","b","b","b","b","b","b","b","b","c","c","c","c","c","d","d","e","e","e","e","f","f","f","f","f","g","g","g","g","g","g","g","g","g"]
let arrl=arr.length;
let timer=3000/arrl
var i, _i, _results;
_results = [];
for (i = _i = 0; _i <= arrl-1; i = ++_i) {
_results.push((function(i) {
return setTimeout(function() {
return myshot.play(arr[i]);
}, i * timer);
})(i));
}
}



handleShot5() {
var myshot = new window.Howl({
  src: ['audio/playback.mp3'],
  volume:0.2,
  sprite: {
    a: [0, 1000],
    g: [1000, 1000],
    c: [2000, 1000],
    f: [3000, 1000],
    e: [4000, 1000],
    d: [5000, 1000],
    b: [6000, 1000]
}
});
// let arr=["a","a","a","a","a","a","a","a","a","a","a","b","b","b","b","b","c","c","c","c","c","c","c","c","c","d","d","e","e","e","e","f","f","f","f","f","f","f","f","f","f","f","f","f","g","g","g","g","g","g"]
let arr=["a","a","a",,"b","f","f","g","g","g","g","g","g"]

let arrl=arr.length;
let timer=5000/arrl
var i, _i, _results;
_results = [];
for (i = _i = 0; _i <= arrl-1; i = ++_i) {
_results.push((function(i) {
return setTimeout(function() {
return myshot.play(arr[i]);
}, i * timer);
})(i));
}
}

    render(){
    return(
        <div className="mainbox">
        <h2 className="display-3 text-center">Listen to all the air raids on Yemen</h2>
        {/* <ReactHowler
        src='audio/howl.ogg'
        playing={true}
        // loop={true}
        /> */}
        <h1>{this.state.count}</h1>
        <button onClick={this.handleClick}>Play alphabet!</button>
        <br/>
        <button onClick={this.handleShot}>Play 1 shot!</button>
        <button onClick={this.handleShot1}>Play 10 shots!</button>
        <button onClick={this.handleShot2}>Play 20 shots!</button>
        <button onClick={this.handleShot3}>Play 30 shots!</button>
        <button onClick={this.handleShot4}>Play 40 shots!</button>
        <button onClick={this.handleShot5}>Play 50 shots!</button>
        <div className="dataviz">
        <ResponsiveBarCanvas
          margin={{
            top: 0,
            right: 80,
            bottom: 0,
            left: 80
          }}
        data={YemenDBrev}

        indexBy="Date"
        keys={[
        // "Saada",
        // "Taiz",
        // "Sanaa",
        // "Hajja",
        "Hodeidah"
        // "Marib",
        // "Amanat al Asimah",
        // "Jawf",
        // "Bayda",
        // "Lahj",
        // "Amran",
        // "Shabwa",
        // "Aden",
        // "Ibb",
        // "Dhamar",
        // "Dhalie",
        // "Abyan",
        // "Mahwit",
        // "Raymah",
        // "Hadramawt"
        ]}
      padding={0}
      colors={["#1b3665"]}

      // colors={["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928"]}
      // colors={["#F7955C","#DD9749","#C0983E","#A2973B","#85953F","#699148","#4F8B53","#36845E","#217C68","#16736E","#1D6971","#2C5F70","#3A546B","#454862","#4C3D56","#4F3348","#4E2A3A","#49232C","#421E1F","#381914"]}
      // colors={["#854734","#844F2C","#7F5826","#766224","#6C6B28","#5F7332","#507B41","#3F8154","#2D8668","#1E8B7E","#228E92","#3B8FA4","#5B8EB1","#7D8CB8","#9E88B8","#BC83B2","#D57FA7","#E87D97","#F57F85","#FA8572"]}
      // colors="green_blue"
      maxValue={52}
      layout="horizontal"
      labelTextColor="inherit:darker(1.4)"
      labelSkipWidth={16}
      labelSkipHeight={16}
      axisTop={{
        "tickSize": 5,
        "tickPadding": 5,
        "tickRotation": 0,
        "legend": "",
        "legendOffset": 36
      }}
      />
      </div>
      {/* <div className="slidercontainer">
          <Draggable
            axis="y"
            handle=".handle"
            defaultPosition={{x: 0, y: 0}}
            position={null}
            grid={[25, 25]}
            scale={1}
            onStart={this.handleStart}
            onDrag={this.handleDrag}
            onStop={this.handleStop}>
            <div>
            <Container fluid className="handle sliderbox">
                <div className="circlebox"></div>
            </Container>
            </div>
        </Draggable>  
      </div> */}
    </div> 
    )   
}
}
export default NivoDemo